import { styled } from 'styled-components';

import PlusSVG from '../assets/plus-icon.svg?react';

export const StyledPlusIcon = styled(PlusSVG)`
  width: 24px;
  height: 24px;
`;
